var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPowerFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3845_166519)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0594 9.34058L12.2281 8.92495V4.8562C12.2281 2.38433 10.2594 0.371826 7.83125 0.371826C5.425 0.371826 3.7625 1.68433 3.47812 3.7187H1.81562C1.44375 3.7187 1.1375 3.9812 1.05 4.35308L0.7 5.86245C0.65625 5.97183 0.65625 6.05933 0.65625 6.10308V12.2718C0.65625 12.6218 0.7875 12.9718 1.05 13.2125C1.3125 13.4531 1.64063 13.6062 1.99063 13.6062L5.8625 13.5843C6.60625 13.5843 7.19688 12.9718 7.19688 12.25V6.0812C7.19688 6.03745 7.19687 5.9937 7.175 5.97183L6.78125 4.35308C6.71562 3.9812 6.3875 3.7187 6.01562 3.7187H4.44062C4.74687 1.99058 6.36562 1.3562 7.7875 1.3562C9.66875 1.3562 11.2 2.9312 11.2 4.8562V8.92495L10.3687 9.34058C10.1937 9.42808 10.1062 9.60308 10.1062 9.77808V12.6875C10.1062 13.1906 10.5219 13.6062 11.025 13.6062H12.4031C12.9062 13.6062 13.3219 13.1906 13.3219 12.6875V9.77808C13.3438 9.60308 13.2344 9.42808 13.0594 9.34058ZM4.50623 6.93434H3.3906C3.10623 6.93434 2.88748 6.71559 2.88748 6.43121C2.88748 6.14684 3.1281 5.92809 3.3906 5.92809H4.50623C4.7906 5.92809 5.00935 6.14684 5.00935 6.43121C5.00935 6.71559 4.76873 6.93434 4.50623 6.93434Z",
    fill: "#003844"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3845_166519"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerFill);
export default __webpack_public_path__ + "static/media/power-fill.36d69f471b7219107973f741b89d15ed.svg";
export { ForwardRef as ReactComponent };